import { Announcement } from "@domain/announcement/announcement";
import { AnnouncementReceivedService } from "@domain/announcement/announcement-received-service";
import { AnnouncementService } from "@domain/announcement/announcement-service";
import { observable } from "micro-observables";

export class AnnouncementManager {
	private readonly _announcement = observable<Announcement | undefined>(undefined);
	announcement = this._announcement.readOnly();

	private loadingAnnouncementId: string | undefined = undefined;

	constructor(
		private readonly announcementService: AnnouncementService,
		readonly announcementReceivedService: AnnouncementReceivedService,
	) {
		announcementReceivedService.onAnnouncementIdReceived.add(this.getAnnouncement.bind(this));
	}

	async markAsViewed(id: string): Promise<void> {
		await this.announcementService.markAsViewed(id);
		this._announcement.set(undefined);
	}

	private async getAnnouncement(id: string) {
		if (id === this.loadingAnnouncementId) return;
		this.loadingAnnouncementId = id;
		this._announcement.set(await this.announcementService.getAnnouncement(id));
	}
}
